import request from '@/utils/request'

// 查询列表
export function apiMdmItemOrganizationItemList (query) {
  return request({
    url: '/mdm/mdmItemOrganizationItem/list',
    method: 'get',
    params: query
  })
}

// 修改
export function apiMdmItemOrganizationItemUpdate (data) {
  return request({
    url: '/mdm/mdmItemOrganizationItem',
    method: 'put',
    data: data
  })
}

// 类别集名称-物料类别
export function apiItemCategorySetPullDownList (query) {
  return request({
    url: '/mdm/itemCategorySet/pullDownList',
    method: 'get',
    params: query
  })
}

// 类别代码
export function apiItemCategoryCodePullDownList (query) {
  return request({
    url: '/mdm/itemCategoryCode/pullDownList',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiMdmItemOrganizationItemNewExport (data) {
  return request({
    url: '/mdm/mdmItemOrganizationItem/v2/export',
    method: 'post',
    data: data
  })
}
